/**
 * @generated SignedSource<<6106f34f1da05e19191cff41bffd4296>>
 * @relayHash 1d90cf309bc3da9c32297c3b1e952819
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiNotificationLogsPageQuery } from './uiNotificationLogsPageQuery.graphql';

const node: PreloadableConcreteRequest<uiNotificationLogsPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
    "metadata": {},
    "name": "uiNotificationLogsPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
